import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import avatar1 from "../../assets/images/users/ic_defaul_avatar2.png";
import { capitalizeFirstLetter } from "utils";
import {
  COLOR_USER_TYPE_BAR,
  COLOR_USER_TYPE_LOG,
  getPlatFormImage,
  USER_TYPE_BAR_OPTION,
  USER_TYPE_LOG_OPTION,
} from "helpers/constans";

interface TypesProps {
  item?: any;
  screen?: string;
}

const GroupInfoUser = ({ item, screen }: TypesProps) => {
  const { t } = useTranslation();

  const [platform, setPlatform] = useState({ name: "", image: "" });

  useEffect(() => {
    if (item) {
      const platform =
        screen === "users"
          ? item?.provider_type
          : item?.plaform || item?.platform;

      let imgPlatform = getPlatFormImage(platform);
      let name = platform;
      if (name === "guest") {
        name = "-";
      } else if (name === "default") {
        name = "Email";
      }
      setPlatform({ name: name, image: imgPlatform });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item]);

  return (
    <React.Fragment>
      {item ? (
        <div className="d-flex align-items-center gap-2">
          <div
            style={{
              height: "48px",
              width: "48px",
              minWidth: "48px",
              overflow: "hidden",
              borderRadius: "15px",
              objectFit: "cover",
              // zIndex: 99,
            }}
          >
            <img
              src={item?.profile_image_url || avatar1}
              className="rounded-circle avatar-sm"
              alt={item?.nickname}
              height={48}
              width={48}
              style={{
                minWidth: "48px",
                overflow: "hidden",
                borderRadius: "50%",
                objectFit: "cover",
              }}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = avatar1;
              }}
            />
          </div>
          <div>
            <div>{item?.nickname}</div>
            <small className="text-secondary">{item?.email}</small>
            <div className="text-left d-flex align-items-center text-secondary">
              <small className="d-flex gap-1">
                {platform?.image && (
                  <img
                    src={platform?.image}
                    width={16}
                    height={16}
                    alt="platform"
                  />
                )}
                {t(
                  capitalizeFirstLetter(
                    platform?.name === "default" || platform?.name === "guest"
                      ? "Email"
                      : platform?.name
                  )
                )}
              </small>

              <small className="px-1"> | </small>

              <small
                className={`rounded-pill px-0 badge text-${
                  COLOR_USER_TYPE_BAR[item?.type] || "secondary"
                }`}
              >
                {t(
                  USER_TYPE_BAR_OPTION?.find(
                    (el: any) => el?.value === item?.type
                  )?.label || ""
                )}
              </small>
            </div>
          </div>
        </div>
      ) : (
        "-"
      )}
    </React.Fragment>
  );
};

export default GroupInfoUser;
